import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import ImageHelper from "../Helpers/ImageHelper";
import ServiceMenu1 from "../components/NavBar/ServiceMenu1";
import { MobileMenuModal } from "./MobileMenuModal/MobileMenuModal";
import FlashOffers from "../components/FlashOffers/FlashOffers";

const Header = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <div className="">
      <MobileMenuModal handleClose={handleClose} show={show} />
      <header id="header">
        <div className="container main-menu">
          <div className="row align-items-center justify-content-between d-flex">
            <div id="logo-container">
              <Link to="/">
                <img
                  src={ImageHelper.Logo}
                  width={160}
                  height={60}
                  alt=""
                  title="TZ Creation - HOME | Graphic Design | Web Dev"
                />
              </Link>
            </div>
            <Button
              variant="primary"
              id="mobile-nav-toggle"
              aria-label="Open menu"
              onClick={handleShow}
            >
              <i className="lnr lnr-menu"></i>
            </Button>
            <nav id="nav-menu-container">
              <ul className="nav-menu d-flex align-items-center">
                <li>
                  <Link className="navlink" to="/">
                    Home
                  </Link>
                </li>
                <li>
                  <Link className="navlink" to="/about">
                    About
                  </Link>
                </li>
                <ServiceMenu1 />

                <li>
                  <Link className="navlink" to="/portfolio">
                    Portfolio
                  </Link>
                </li>
                <li>
                  <Link className="navlink" to="/case-study">
                    Case Studies
                  </Link>
                </li>
                <li>
                  <Link className="navlink" to="/packages">
                    Packages
                  </Link>
                </li>
                <li>
                  <Link
                    className="navlink primary-btn text-uppercase px-4 text-light"
                    to="/contact-us"
                  >
                    Contact Us
                  </Link>
                </li>
              </ul>
            </nav>
          </div>
        </div>
        <FlashOffers />
      </header>
      <div style={{ height: "76px", marginBottom: "40px" }}> </div>
    </div>
  );
};

export default Header;
